(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _watching = _interopRequireDefault(require("../util/watching"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  var others = document.querySelectorAll('a[href^="http://"]:not([href^="http://' + location.host + '"]),' + ' a[href^="https://"]:not([href^="https://' + location.host + '"]),' + ' a[href$="pdf"]');
  others.forEach(function (other) {
    other.addEventListener('click', function (event) {
      event.preventDefault();
      window.open(this.href);
    });
  });
});

},{"../util/watching":7}],2:[function(require,module,exports){
"use strict";

require("./lus_anchor_navigation");

require("./lus_navigation");

require("./lus_slider");

},{"./lus_anchor_navigation":3,"./lus_navigation":4,"./lus_slider":5}],3:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  // click event
  document.querySelectorAll('.nav-main, .back-to-top').forEach(function (trigger) {
    trigger.addEventListener('click', clickHandler);
  });

  function clickHandler(event) {
    // click link_cloud_trigger if clicked menu link is a hash
    if (event.target.matches('a')) {
      var href = event.target.href;
      var currenturl = window.location.origin + window.location.pathname;
      var newurl = href.substring(0, href.indexOf('#'));
      var thehash = href.substring(href.indexOf('#'), href.length);

      if (0 === newurl.length) {
        newurl = thehash;
        thehash = '#body';
      }

      if (currenturl == newurl) {
        var thehashElement = document.querySelector(thehash);

        if (null !== thehashElement) {
          event.preventDefault();
          var bodyRect = document.body.getBoundingClientRect();
          var elemRect = thehashElement.getBoundingClientRect();
          var offset = elemRect.top - bodyRect.top;
          window.scroll({
            top: offset,
            behavior: 'smooth'
          }); // navigation selected setzen, url Zeile setzen

          document.querySelectorAll('.nav a').forEach(function (element) {
            element.classList.remove('selected');
          });

          if ('#body' == thehash) {
            document.querySelector('.nav a[href="' + window.location.pathname + '"]').classList.add('selected');
            window.history.pushState('', document.title, window.location.pathname + window.location.search);
          } else {
            document.querySelector('.nav a[href*="/' + thehash + '"]').classList.add('selected');
            window.history.pushState('', document.title, href);
          }
        }
      }
    }
  } // add "selected" to menu if hash is in URL

  /*var urlhash = window.location.hash;
  if (urlhash.length > 1 && urlhash.indexOf('&gid') == '-1') {
      var menueItem = document.querySelector('.nav a[href*="/' + urlhash + '"]');
      if ( menueItem ) {
          menueItem.classList.add('selected');
          // click menu link if hash is in URL
          // menueItem.click();
      }
  }*/

});

},{}],4:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  // mobile navigation: kann mehrere trigger icons enthalten, die die jeweiligen Menues/Masken öffnen
  document.querySelectorAll('.nav-mobile span[class^="trigger"]').forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      var target_class = trigger.getAttribute('data-trigger');
      var target_element = document.querySelector('.' + target_class); // alle geöffneten trigger / targets schließen

      document.querySelectorAll('.nav-mobile span[class$="-is-open"]').forEach(function (opentrigger) {
        var what_to_open = opentrigger.getAttribute('data-trigger');

        if (what_to_open != target_class) {
          opentrigger.classList.remove(what_to_open + '-is-open');
          document.querySelector('.' + what_to_open).classList.remove('is-visible');
        }
      }); // trigger markieren und neues öffnen oder schliessen

      trigger.classList.toggle(target_class + '-is-open');
      target_element.classList.toggle('is-visible');

      if (target_class == 'search' && target_element.classList.contains('is-visible')) {
        target_element.querySelector('input[type="text"]').focus();
      }
    });
  }); // main navigation

  document.querySelectorAll('.nav-main').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      // klick auf einen Menupunkt schließt Menu
      if (event.target.matches('a') || event.target.matches('span')) {
        document.querySelector('.nav-mobile .trigger-nav-main').click();
      }
    });
  }); // klick aufs overlay schließt menu

  document.querySelector('.mobile-overlay').addEventListener('click', function (event) {
    document.querySelector('.nav-mobile .trigger-nav-main').click();
  });
});

},{}],5:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var clickable = true;
  var theSlider = new LusSlider({
    selector: '.slider_rotator',
    controls: false
  });
  var theGallery = new LusSlider({
    selector: '.my-gallery2',
    autoSpeed: 7500,
    controls: false,
    dots: false
  }); // Setup the breakpoint variable

  var breakpoint; // Calculate breakpoint on page load

  breakpoint = getBreakpoint(); //if ( breakpoint == 'small' || breakpoint == 'medium' ) { var theJobs = new LusSlider({ selector: '.jobs', autoSpeed:7500, controls:true, dots: false}); }

  document.querySelectorAll('.slider_rotator .html5_player').forEach(function (h5player) {
    h5player.addEventListener('click', function player(event) {
      this.classList.add('plyr');
      this.classList.add('js-player');
      this.removeAttribute('muted');
      this.removeEventListener('click', player);
      var players = Plyr.setup('.slider_rotator .html5_player', {
        youtube: {
          noCookie: true
        }
      });
    });
  });
}); // Get the current breakpoint

var getBreakpoint = function getBreakpoint() {
  return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '');
};

var LusSlider = function () {
  'use strict';

  var Constructor = function Constructor(options) {
    var defaults = {
      selector: '.lus_slider',
      prevId: 'prevBtn',
      prevText: '<',
      nextId: 'nextBtn',
      nextText: '>',
      orientation: '',
      //  'vertical' is optional;
      auto: true,
      autoSpeed: 5000,
      fadeOutSpeed: 1500,
      fadeInSpeed: 1500,
      controls: true,
      dots: true
    };
    options = Object.assign({}, defaults, options);
    var clickable = true;
    document.querySelectorAll(options.selector).forEach(function (slider) {
      // init
      var slides = slider.querySelectorAll('.slide');

      if (slides.length > 0) {
        for (var index = 0; index < slides.length; index++) {
          slides[index].setAttribute('data-pos', index);
          slides[index].style.zIndex = '1';
        }

        var slide = slides[0];
        slide.classList.add('activeslide');
        slide.style.opacity = '1';
        slide.style.zIndex = '3';

        if (options.dots == true && slides.length > 1) {
          var element1 = document.createElement('div');
          element1.classList.add('slider_dots');

          for (index = 0; index < slides.length; index++) {
            var element2 = document.createElement('a');
            element2.setAttribute('data-pos', index);
            var element3 = document.createElement('span');
            element2.appendChild(element3);
            element1.appendChild(element2);
          }

          slider.appendChild(element1);
          slider.querySelector('.slider_dots a').classList.add('active');
          var dots = slider.querySelectorAll('.slider_dots a').forEach(function (dot) {
            dot.addEventListener('click', function (event) {
              slideTo(parseInt(dot.getAttribute('data-pos'), 10));
            });
          });
        } // functions


        var slideIt = function slideIt(dir) {
          if (slides.length > 1) {
            var current = slider.querySelector('.activeslide');
            var currentNr = parseInt(current.getAttribute('data-pos'), 10);
            var newSlideIndex;

            if (dir == 'prev') {
              newSlideIndex = currentNr - 1;
            } else {
              newSlideIndex = currentNr + 1;
            }

            if (newSlideIndex >= slides.length) {
              newSlideIndex = 0;
            }

            if (newSlideIndex < 0) {
              newSlideIndex = slides.length - 1;
            }

            slideTo(newSlideIndex);
          }

          return false;
        };

        var slideTo = function slideTo(newNr) {
          var current = slider.querySelector('.activeslide');
          var currentNr = parseInt(current.getAttribute('data-pos'), 10);

          if (clickable == false || currentNr == newNr) {
            return false;
          } //clickable = false;


          var clickableTimer = setTimeout(function () {
            clickable = true;
          }, 1500);
          clearInterval(slideauto);
          var newSlide = slides[newNr];
          newSlide.style.zIndex = '2';
          newSlide.animate([{
            opacity: 0
          }, {
            opacity: 1
          }], {
            duration: options.fadeInSpeed,
            fill: 'forwards'
          });
          current.animate([{
            opacity: 1
          }, {
            opacity: 0
          }], {
            duration: options.fadeOutSpeed,
            fill: 'forwards'
          });
          var slidefade = setTimeout(function () {
            current.style.zIndex = '1';
            current.classList.remove('activeslide');
            newSlide.style.zIndex = '3';
            newSlide.classList.add('activeslide');

            if (options.dots == true) {
              var dots = slider.querySelectorAll('.slider_dots a');
              dots[currentNr].classList.remove('active');
              dots[newNr].classList.add('active');
            } // auto


            if (options.auto == true) {
              slideauto = setTimeout(function () {
                slideIt('next');
              }, options.autoSpeed);
            }
          }, options.fadeOutSpeed);
          return false;
        }; // controls


        if (options.controls == true && slides.length > 1) {
          var html = '<div class="slider_controls"><a class="' + options.prevId + '">' + options.prevText + '</a>' + ' <a class="' + options.nextId + '">' + options.nextText + '</a></div>';
          slider.insertAdjacentHTML('beforeend', html);
          slider.querySelector('.slider_controls a:first-child').addEventListener('click', function (event) {
            slideIt('prev');
          });
          slider.querySelector('.slider_controls a:last-child').addEventListener('click', function (event) {
            slideIt('next');
          });
        } // auto


        if (options.auto == true) {
          var slideauto = setTimeout(function () {
            slideIt('next');
          }, options.autoSpeed);
        }
      }
    });
  };

  return Constructor;
}();

},{}],6:[function(require,module,exports){
"use strict";

require("./components");

require("./application");

},{"./application":1,"./components":2}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//import $ from 'jquery';
function extend(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    if (source) {
      for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
          var descriptor = Object.getOwnPropertyDescriptor(source, prop);
          Object.defineProperty(obj, prop, descriptor);
        }
      }
    }
  });
  return obj;
}

var selectors = [];
var observer = new MutationObserver(function (objects) {
  objects.forEach(function (object) {
    var _iterator = _createForOfIteratorHelper(object.addedNodes),
        _step;

    try {
      var _loop = function _loop() {
        var node = _step.value;

        if (Node.ELEMENT_NODE !== node.nodeType) {
          return "continue";
        }

        selectors.forEach(function (watching) {
          if (node.matches(watching.selector)) {
            watching.createInstance(node);
          }

          watching.createInstances(node.querySelectorAll(watching.selector));
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
});
observer.observe(document, {
  childList: true,
  subtree: true
});
var Watching = {
  create: function create(selector, definition) {
    var base = Object.create(this);
    extend(base, definition);
    base.first = true;
    base.selector = selector;
    selectors.push(base);
    base.createInstances(document.querySelectorAll(selector));
  },
  createInstances: function createInstances(elements) {
    var _iterator2 = _createForOfIteratorHelper(elements),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var element = _step2.value;
        this.createInstance(element);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  },
  createInstance: function createInstance(element) {
    if (this.first) {
      this.config();
      this.first = false;
    }

    var instance = Object.create(this, {
      element: {
        value: element,
        writable: false
      },
      $element: {
        value: element,
        writable: false
      }
    });
    instance.init();
  },
  config: function config() {},
  init: function init() {}
};

var _default = function _default(selector, definition) {
  return Watching.create(selector, definition);
};

exports.default = _default;

},{}]},{},[6]);
